module.exports = __webpack_public_path__ + "img/complete_logo.9fa337d2.png";